import { useTranslation } from "react-i18next";
import { Banknote, Coins, MinusCircle, Wallet } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";

const money = (value) => Number(value || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });

// بطاقات إجماليات الرواتب بثيم الصفحة الرئيسية: الأساسي، البدلات، الخصومات، الصافي المستحق.
export const PayrollKpis = ({ run }) => {
  const { t } = useTranslation();
  if (!run) return null;
  const cards = [
    { key: "basic", value: run.total_basic, icon: Banknote, tone: "emerald" },
    { key: "allowances", value: run.total_allowances, icon: Coins, tone: "sky" },
    { key: "deductions", value: run.total_deductions, icon: MinusCircle, tone: "rose" },
    { key: "net", value: run.total_net, icon: Wallet, tone: "orange" },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4" data-testid="payroll-kpis">
      {cards.map((c) => (
        <StatCard key={c.key} testId={`payroll-kpi-${c.key}`} icon={c.icon} tone={c.tone}
                  label={`${t(`payrollCounter.${c.key}`)} · ${run.currency}`} value={money(c.value)} />
      ))}
    </div>
  );
};
